import { byCode } from "../assets/languages"

export const LanguageLabelTransformer = (code: string) => {
    return byCode[code]?.name ?? code
}
